import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { Edit2, Tag, Search } from 'react-feather';
import config from '../../../../config';
import useEntityCrud from '../shared/useEntityCrud';
import KpiStrip from '../shared/KpiStrip';
import Pagination from '../shared/Pagination';

const CategoriesTab = ({ q, page, onPageChange, onEdit, onAdd, canManage, reloadKey }) => {
    const { t } = useTranslation();
    const concessionaireId = localStorage.getItem('concessionaireId');

    const { paged, total, pageCount, page: safePage, loading } = useEntityCrud({
        endpoint: `${config.hostname}/category/getcategorybyconcessionaire`,
        payload: { category_concessionaire_id: concessionaireId },
        searchFields: ['category_name'],
        q,
        page,
        pageSize: 15,
        dependencies: [reloadKey],
    });

    const tiles = useMemo(() => ([
        { label: 'Total categories', value: total, icon: <Tag size={16} />, tone: 'accent' },
    ]), [total]);

    return (
        <>
            <KpiStrip tiles={tiles} />
            <div className="v3-card v3-sadmin-list-card">
                <div className="v3-sadmin-list-header">
                    <div className="v3-sadmin-list-title">
                        <h2 className="v3-title">{t('Categories')}</h2>
                        <span className="v3-sadmin-list-count">{total}</span>
                    </div>
                    <div className="v3-sadmin-list-actions">
                        {canManage && (
                            <button type="button" className="v3-btn v3-btn-primary" onClick={onAdd}>
                                + {t('Add category')}
                            </button>
                        )}
                    </div>
                </div>
                <div className="v3-sadmin-table-wrap">
                    {loading ? (
                        <div className="v3-sadmin-empty"><p>{t('Loading categories…')}</p></div>
                    ) : total === 0 ? (
                        <div className="v3-sadmin-empty">
                            <Search size={28} />
                            <h3>{t('No categories found')}</h3>
                            <p>{q ? t('Try clearing the search.') : t('Add your first category to get started.')}</p>
                        </div>
                    ) : (
                        <table className="v3-sadmin-table">
                            <thead>
                                <tr>
                                    <th>{t('Category')}</th>
                                    {canManage && <th style={{ width: 80 }}>{t('Actions')}</th>}
                                </tr>
                            </thead>
                            <tbody>
                                {paged.map((row) => (
                                    <tr key={row._id} onClick={() => canManage && onEdit(row._id)}>
                                        <td className="v3-sadmin-cell-strong">{row.category_name}</td>
                                        {canManage && (
                                            <td onClick={(e) => e.stopPropagation()}>
                                                <div className="v3-sadmin-row-actions">
                                                    <button
                                                        type="button"
                                                        className="v3-sadmin-icon-btn"
                                                        onClick={() => onEdit(row._id)}
                                                        aria-label={t('Edit')}
                                                    >
                                                        <Edit2 size={13} />
                                                    </button>
                                                </div>
                                            </td>
                                        )}
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    )}
                </div>
                <Pagination
                    page={safePage}
                    pageCount={pageCount}
                    total={total}
                    pageSize={15}
                    onPageChange={onPageChange}
                />
            </div>
        </>
    );
};

export default CategoriesTab;
